var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1177_283",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1177_283",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB50lEQVR4nO2Z7UrDMBiFD4PtClzdvChxIkO8AMEbmV93oZteiIi/3dR96BAvQbbfvhJ4CyG0TZo2abb1wIHCurznadMmaYBatWqVoRaAPoAHADMAawDkyGuuMeKaonYpOgawdBhc5y8AvSIADQA3FQKQ4ivOlFu3AYQnxZc23YkC9ZEpRIv7JQXqpekLoB9AWNL4xATkMYCgpPHQBGQRQFDSWIwzWq0CCEoai4xa0YZYq50BmQOI4E4R13AKEhd4cwSzz23LtZyAtAGM+XgKoFsihLgwE6VtZyBwBKNCdAyzFAIpGyYNwguICjOzhMmC8AZSFEaG+EiA8ApiC2MC4R0kL4wpRCUgcjjhdx4TVHU4fHzemC9CmVms/yxDTKTjbwCnfHcOAJwB+OHfXhlWB0O+QFSIiP2S0cYTgD1lFE+DIR8gSRCxxFL0goHW7GcA5wCa0nkyjGij7RtEHRCzHlibqYkXkKhECKS02XUNohuJiyhp2rOx0/jI1zR+axZWFJC12hqQVQAhSeNfExCT/lm1pyYgowCCksZ3O/URuxn499+5Ml/LVC+AwJTgPwCHyKnrAIKT4gEs1OANyFDuxMB2MzSW2LP7rBBiYdOd0tTkN8WQ3+EuB80Vr+vvuabxg12rVi2k6h/tZAX3+lLjIgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.ecea27fab984adefa3535c75767bac3e.svg";
export { ForwardRef as ReactComponent };